module.exports = __webpack_public_path__ + "media/assets/img/company/logo totalredi-9cbb8f379eeea5a52dd6144d38cee657.png";